import { render, staticRenderFns } from "./receivableDetail.vue?vue&type=template&id=4ab52535&scoped=true&"
import script from "./receivableDetail.vue?vue&type=script&lang=js&"
export * from "./receivableDetail.vue?vue&type=script&lang=js&"
import style0 from "./receivableDetail.vue?vue&type=style&index=0&id=4ab52535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab52535",
  null
  
)

export default component.exports